import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when user clicks "Continue Editing" on the dashboard draft prompt
 * Event: dental_portal:dashboard:continue_draft_clicked
 */
export function fireDashboardContinueDraftClicked(): void {
  PosthogService.getInstance().track('dental_portal:dashboard:continue_draft_clicked');
}
